export const CHANGE_MARK = '*';
export const EXTERNAL_REF_KEY = '$ref';
export const ID_START_KEY = '#';
export const ID_SEPARATOR_KEY = '.';
export const HEX_COLOR_START_KEY = '#';
export const DESKTOP_BREAKPOINT = 'desktop'; // TEMP while different preview breakpoints will be implemented
export const AUTOGEN_COLORS_CATEGORY = 'autogen_brandStyleColors'; // Need to create custom brand colors object to use it in component Relations
export const AUTOGEN_COLOR_ID = 'autogen_brandStyle_id_'; // Need to create custom brand colors object to use it in component Relations
export const AUTOGEN_COLOR_NAME = 'autogen_brandStyle_name_'; // Need to create custom brand colors object to use it in component Relations
